module.exports = __webpack_public_path__ + "static/media/NoirPro-Light.defbb591.eot";